<script lang="ts" setup>
import { defineComponent, PropType } from 'vue'

import ReviewCard from '@base/components/ReviewCard/ReviewCard.vue'

import { ReviewCard as ReviewCardType } from '@base/_types/ReviewCard'

defineComponent({
  name: 'ReviewCardStack'
})

const props = defineProps({
  reviews: {
    type: Array as PropType<ReviewCardType[]>,
    default: () => []
  }
})

const handleEmit = (e) => {
  emit('dropdownMenu', e)
}

const emit = defineEmits(['dropdownMenu'])
</script>

<template>
  <div data-test="review-card-stack" class="review-card-stack">
    <div v-if="reviews">
      <ReviewCard
        v-for="(review, idx) in reviews"
        :key="idx"
        :review="review"
        @dropdownMenu="handleEmit($event)"
      />
    </div>
  </div>
</template>
